// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elsa-flowchart-diagram-designer-v2 .x6-graph-background {
    background-color: var(--mud-palette-surface);
}

.elsa-flowchart-diagram-designer-v2 .x6-widget-selection-box {
    border: dashed 2px var(--mud-palette-gray-light);
    box-shadow: none;
}

.elsa-flowchart-diagram-designer-v2 .x6-widget-selection-inner {
    border: dashed 2px var(--mud-palette-gray-light);
    box-shadow: none;
}

.elsa-flowchart-diagram-designer-v2 .x6-widget-transform {
    border: none;
}

.elsa-flowchart-diagram-designer-v2 .elsa-snapline .x6-widget-snapline-horizontal,
.elsa-flowchart-diagram-designer-v2 .elsa-snapline .x6-widget-snapline-vertical {
    stroke: var(--mud-palette-secondary);
}

.elsa-flowchart-diagram-designer-v2 .elsa-activity-wrapper-badge {
    
}

.elsa-flowchart-diagram-designer-v2 .elsa-activity-wrapper-badge.has-retries .mud-badge-wrapper .mud-badge {
    background-color: #FFEB3B !important;
}

.elsa-flowchart-diagram-designer-v2 .elsa-activity {
    height: 100%;
}

/* Use equal 16px padding all around */
.elsa-flowchart-diagram-designer-v2 .activity-grid {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    column-gap: 12px;
    padding: 16px; /* top/right/bottom/left = 16px */
    border-radius: 8px;
}

/* Icon container */
.elsa-flowchart-diagram-designer-v2 .activity-icon {
    background-color: #1976d2;
    width: 42px;
    height: 42px;
    min-width: 42px;     /* enforce at least 42px */
    min-height: 42px;
    flex: none;          /* don’t let flex or grid shrink it */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
}

/* Middle content (label, type, ports, description) */
.elsa-flowchart-diagram-designer-v2 .activity-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* First line: activity label stays default color */
.elsa-flowchart-diagram-designer-v2 .activity-label {
    white-space: nowrap;
}

/* Second line: lighter grey to mimic original */
.elsa-flowchart-diagram-designer-v2 .activity-type {
    color: var(--mud-palette-gray-light);
    font-size: 0.75rem; /* slightly smaller */
    white-space: nowrap;
}

/* Embedded ports row */
.elsa-flowchart-diagram-designer-v2 .activity-ports {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
}

.elsa-flowchart-diagram-designer-v2 .activity-ports .mud-input.mud-input-outlined .mud-input-outlined-border  {
    border-style: dashed !important;
}

/* Optional description below */
.elsa-flowchart-diagram-designer-v2 .activity-description {
    margin-top: 4px;
    font-size: 0.75rem;
    color: #666;
}

/* Menu on the right: vertically center */
.elsa-flowchart-diagram-designer-v2 .activity-menu {
    align-self: center;
}
`, "",{"version":3,"sources":["webpack://./css/designer.v2.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;AAChD;;AAEA;IACI,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;AAEA;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa,EAAE,iCAAiC;IAChD,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe,MAAM,0BAA0B;IAC/C,gBAAgB;IAChB,UAAU,WAAW,qCAAqC;IAC1D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,mDAAmD;AACnD;IACI,mBAAmB;AACvB;;AAEA,gDAAgD;AAChD;IACI,oCAAoC;IACpC,kBAAkB,EAAE,qBAAqB;IACzC,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,+BAA+B;AAC/B;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;AACtB","sourcesContent":[".elsa-flowchart-diagram-designer-v2 .x6-graph-background {\n    background-color: var(--mud-palette-surface);\n}\n\n.elsa-flowchart-diagram-designer-v2 .x6-widget-selection-box {\n    border: dashed 2px var(--mud-palette-gray-light);\n    box-shadow: none;\n}\n\n.elsa-flowchart-diagram-designer-v2 .x6-widget-selection-inner {\n    border: dashed 2px var(--mud-palette-gray-light);\n    box-shadow: none;\n}\n\n.elsa-flowchart-diagram-designer-v2 .x6-widget-transform {\n    border: none;\n}\n\n.elsa-flowchart-diagram-designer-v2 .elsa-snapline .x6-widget-snapline-horizontal,\n.elsa-flowchart-diagram-designer-v2 .elsa-snapline .x6-widget-snapline-vertical {\n    stroke: var(--mud-palette-secondary);\n}\n\n.elsa-flowchart-diagram-designer-v2 .elsa-activity-wrapper-badge {\n    \n}\n\n.elsa-flowchart-diagram-designer-v2 .elsa-activity-wrapper-badge.has-retries .mud-badge-wrapper .mud-badge {\n    background-color: #FFEB3B !important;\n}\n\n.elsa-flowchart-diagram-designer-v2 .elsa-activity {\n    height: 100%;\n}\n\n/* Use equal 16px padding all around */\n.elsa-flowchart-diagram-designer-v2 .activity-grid {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    column-gap: 12px;\n    padding: 16px; /* top/right/bottom/left = 16px */\n    border-radius: 8px;\n}\n\n/* Icon container */\n.elsa-flowchart-diagram-designer-v2 .activity-icon {\n    background-color: #1976d2;\n    width: 42px;\n    height: 42px;\n    min-width: 42px;     /* enforce at least 42px */\n    min-height: 42px;\n    flex: none;          /* don’t let flex or grid shrink it */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n}\n\n/* Middle content (label, type, ports, description) */\n.elsa-flowchart-diagram-designer-v2 .activity-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n/* First line: activity label stays default color */\n.elsa-flowchart-diagram-designer-v2 .activity-label {\n    white-space: nowrap;\n}\n\n/* Second line: lighter grey to mimic original */\n.elsa-flowchart-diagram-designer-v2 .activity-type {\n    color: var(--mud-palette-gray-light);\n    font-size: 0.75rem; /* slightly smaller */\n    white-space: nowrap;\n}\n\n/* Embedded ports row */\n.elsa-flowchart-diagram-designer-v2 .activity-ports {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 4px;\n}\n\n.elsa-flowchart-diagram-designer-v2 .activity-ports .mud-input.mud-input-outlined .mud-input-outlined-border  {\n    border-style: dashed !important;\n}\n\n/* Optional description below */\n.elsa-flowchart-diagram-designer-v2 .activity-description {\n    margin-top: 4px;\n    font-size: 0.75rem;\n    color: #666;\n}\n\n/* Menu on the right: vertically center */\n.elsa-flowchart-diagram-designer-v2 .activity-menu {\n    align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
